import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { IconComponent } from '@gains-com/ui-angular';
import { NAME_MISMATCH_PURCHASE_MESSAGE } from '../../common.js';

@Component({
  selector: 'app-name-mismatch-notice',
  imports: [IconComponent],
  templateUrl: './name-mismatch-notice.component.html',
  styleUrl: './name-mismatch-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NameMismatchNoticeComponent {
  readonly message = NAME_MISMATCH_PURCHASE_MESSAGE;

  readonly contactSupport = output<void>();
}
